import { CART_ITEM_STATUS } from "constants/cart";

export const isFilingFiledExternally = (status?: string): boolean =>
  status === CART_ITEM_STATUS.ARCHIVED;
